import PaidOutlined from '@mui/icons-material/PaidOutlined';
import { IAbsenteeismRateItem } from '../../../interfaces/IAbsenteeismRate';
import { AbsenteeismRateCard } from './AbsenteeismRateCard';

export const RankCostCenterWithMoreMedicalCertificate = ({ data }: { data: IAbsenteeismRateItem[] }) => (
  <AbsenteeismRateCard
    icon={<PaidOutlined />}
    title="Taxa de absenteísmo por centro de custo"
    subtitle="Colaboradores com atestado sobre o total do centro de custo"
    data={data}
  />
);
